import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MatDivider } from '@angular/material/divider';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { ActionResponseBody } from '@lib/core/models/action.interface';
import { MemberContract } from '@lib/core/models/contract.interface';
import { MemberProfile } from '@lib/core/models/member.interface';

import { ContractItemComponent } from '@lib/shared-ui/commons/contract-item/contract-item.component';

@Component({
  selector: 'chat-user-profile',
  standalone: true,
  imports: [MatDivider, ContractItemComponent],
  templateUrl: './chat-user-profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatUserProfileComponent {
  protected readonly formatDate = formatDate;

  member = input.required<MemberProfile>();
  memberContracts = input.required<MemberContract[]>();
  memberProfileComments = input.required<ActionResponseBody[]>();
}
